/**
 * Web Image Picker Implementation
 * React Native Image Picker replacement for web
 */

export const launchImageLibrary = (options = {}, callback) => {
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = options.mediaType === 'photo' ? 'image/*' : 'image/*,video/*';
  input.multiple = options.selectionLimit > 1;

  input.onchange = (event) => {
    const files = Array.from(event.target.files);
    
    if (files.length === 0) {
      callback({ didCancel: true });
      return;
    }

    const results = files.map(file => {
      const reader = new FileReader();
      
      return new Promise((resolve) => {
        reader.onload = (e) => {
          resolve({
            uri: e.target.result,
            type: file.type,
            fileName: file.name,
            fileSize: file.size,
            width: 0, // Will be determined after image loads
            height: 0, // Will be determined after image loads
          });
        };
        
        reader.readAsDataURL(file);
      });
    });

    Promise.all(results).then(assets => {
      if (callback) {
        callback({
          assets: options.selectionLimit === 1 ? [assets[0]] : assets,
        });
      }
    });
  };

  input.click();
};

export const launchCamera = (options = {}, callback) => {
  // For web, we'll use the camera API if available
  if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
    navigator.mediaDevices.getUserMedia({ video: true })
      .then(stream => {
        // Create a video element to capture the stream
        const video = document.createElement('video');
        video.srcObject = stream;
        video.play();

        // Create a capture button
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');

        // Simple implementation - in a real app, you'd create a proper camera UI
        setTimeout(() => {
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
          context.drawImage(video, 0, 0);
          
          const dataURL = canvas.toDataURL('image/jpeg');
          
          // Stop the stream
          stream.getTracks().forEach(track => track.stop());
          
          if (callback) {
            callback({
              assets: [{
                uri: dataURL,
                type: 'image/jpeg',
                fileName: `camera_${Date.now()}.jpg`,
                fileSize: dataURL.length,
                width: canvas.width,
                height: canvas.height,
              }]
            });
          }
        }, 3000); // Auto-capture after 3 seconds
      })
      .catch(error => {
        console.warn('Camera not available, falling back to file picker');
        launchImageLibrary(options, callback);
      });
  } else {
    // Fallback to image library
    launchImageLibrary(options, callback);
  }
};

export const showImagePicker = launchImageLibrary;

const ImagePicker = {
  launchImageLibrary,
  launchCamera,
  showImagePicker,
};

export default ImagePicker;